import {Checkbox, Col, Form, Input, InputNumber, Row, Select, Typography} from "antd";
import {FormattedMessage, useIntl} from "react-intl";
import EfficiencyCalculationSelect from "./EfficiencyCalculationSelect/EfficiencyCalculationSelect";
import {createMaxPlayersValidator} from "~Features/MatchProfiles/shared/maxPlayersValidator.ts";
import {MatchProfileNumberFormInput} from "~Features/MatchProfiles/shared/MatchProfileNumberFormInput";

const checkboxOptions = [
  {value: 1, label: "P1"},
  {value: 2, label: "P2"},
  {value: 3, label: "P3"},
  {value: 4, label: "P4"},
  {value: 11, label: "OT1"},
  {value: 12, label: "OT2"},
  {value: 13, label: "OT3"},
  {value: 14, label: "OT4"},
  {value: 15, label: "OT5"},
  {value: 16, label: "OT6"},
];

const CustomLengthFormField = ({fieldName, labelId}) => {
  const {formatMessage} = useIntl()
  return (
    <Col span={2}>
      <Form.Item
        style={{marginBottom: 0, marginLeft: 10}}
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.usePeriodLengthCustomized !==
          currentValues.usePeriodLengthCustomized
        }
      >
        {({getFieldValue}) => (
          <>
            <Form.Item
              name={fieldName}
              label={formatMessage({
                id: labelId,
              })}
              normalize={(value) => (value === null ? undefined : value)}
              rules={[
                {
                  required: getFieldValue("usePeriodLengthCustomized"),
                  message: formatMessage(
                    {id: "form.help.required.field"},
                    {
                      field: formatMessage({
                        id: "period.length",
                      }),
                    },
                  ),
                },
              ]}
            >
              <InputNumber
                style={{width: "100%"}}
                disabled={!getFieldValue("usePeriodLengthCustomized")}
              />
            </Form.Item>
          </>
        )}
      </Form.Item>
    </Col>
  )
}

const BasketballForm = ({form}) => {
  const {formatMessage} = useIntl();
  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item
            labelCol={{span: 7}}
            wrapperCol={{span: 16}}
            required={true}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Please input name",
              },
            ]}
            label={formatMessage({
              id: "name",
              defaulMessage: "Name",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.name",
              defaultMessage: "Name of the match profile",
            })}
          >
            <Input/>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"defaultProfile"}
            label={formatMessage({
              id: "defaultProfile",
              defaulMessage: "Default Profile",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.default",
              defaultMessage: "Is this the default profile for the organization?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>Profile</Typography.Title>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"usePeriodLengthCustomized"}
            label={formatMessage({
              id: "period.length.isCustomized",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.period.length.customized",
            })}
            initialValue={false}
          >
            <Select
              onChange={(value) => {
                if (value) {
                  form.setFieldsValue({periodLength: undefined})
                } else {
                  form.setFieldsValue({
                    periodLengthCustomized: undefined
                  })
                }
              }}
            >
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"numberOfPeriods"}
            label={formatMessage({
              id: "number.of.periods",
              defaultMessage: "numberOfPeriods",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.number.of.periods",
              defaultMessage: "The number of regular periods to play",
            })}
            rules={[
              {
                required: true,
                message: formatMessage(
                  {id: "form.help.required.field"},
                  {
                    field: formatMessage({
                      id: "number.of.periods",
                    }),
                  },
                ),
              },
            ]}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            style={{marginBottom: 0, marginLeft: 10}}
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.usePeriodLengthCustomized !==
              currentValues.usePeriodLengthCustomized
            }
          >
            {({getFieldValue}) => (
              <>
                <MatchProfileNumberFormInput
                  name="periodLength"
                  label={formatMessage({
                    id: "period.length",
                  })}
                  rules={[
                    {
                      required: !getFieldValue("usePeriodLengthCustomized"),
                      message: formatMessage(
                        {id: "form.help.required.field"},
                        {
                          field: formatMessage({
                            id: "period.length",
                          }),
                        },
                      ),
                    },
                  ]}
                  tooltip={formatMessage({
                    id: "form.help.match.profile.period.length",
                    defaultMessage: "The length (in minutes) of a regular period",
                  })}
                >
                  <InputNumber
                    style={{width: "100%"}}
                    disabled={getFieldValue("usePeriodLengthCustomized")}
                  />
                </MatchProfileNumberFormInput>
              </>
            )}
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"halfTimeDuration"}
            label={formatMessage({
              id: "half.time.duration",
              defaultMessage: "Half Time duration (in minutes)",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.half.time",
              defaultMessage: "The length (in minutes) of a half time break",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Row style={{width: "100%", justifyContent: "center", alignItems: "center"}}>
          <Col span={2} style={{marginBottom: '24px'}}>
            <Typography.Text style={{fontWeight: "normal"}}>
              <FormattedMessage id="period.length.customized"/>
            </Typography.Text>
          </Col>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "1"]} labelId="period.1"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "2"]} labelId="period.2"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "3"]} labelId="period.3"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "4"]} labelId="period.4"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "11"]} labelId="period.overtime.1"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "12"]} labelId="period.overtime.2"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "13"]} labelId="period.overtime.3"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "14"]} labelId="period.overtime.4"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "15"]} labelId="period.overtime.5"/>
          <CustomLengthFormField fieldName={["periodLengthCustomized", "16"]} labelId="period.overtime.6"/>

        </Row>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"periodBreakDuration"}
            label={formatMessage({
              id: "period.break.duration",
              defaultMessage: "Period Break duration (in minutes)",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.period.break",
              defaultMessage: "The length (in minutes) of a break between periods",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"shotClock"}
            label={formatMessage({
              id: "season.config.shotClockLength",
              defaultMessage: "shotClock",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.shot.clock.length",
              defaultMessage:
                "The length (in seconds) of the shot clock. A value of '0' indicates that the shot clock will not be used",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maximumRosterSize"}
            label={formatMessage({
              id: "maximum.roster.size",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.max.roster.size",
            })}
            rules={[
              {
                required: true,
                message: formatMessage(
                  {id: "form.help.required.field"},
                  {
                    field: formatMessage({
                      id: "maximum.roster.size",
                    }),
                  },
                ),
              },
              {
                validator: (_, value) =>
                  value > 0
                    ? Promise.resolve()
                    : Promise.reject(
                      formatMessage({
                        id: "form.help.integer.greater.than.zero.field",
                      }, {
                        field: formatMessage({
                          id: "maximum.roster.size",
                        }),
                      })
                    ),
              },
            ]}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maxFoulsPersonal"}
            label={formatMessage({
              id: "max.fouls.personal",
              defaultMessage: "maxFoulsPersonal",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.max.fouls.personal",
              defaultMessage: "The maximum number of personal fouls allowed",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"foulsAllowedTechnical"}
            label={formatMessage({
              id: "fouls.allowed.technical",
              defaultMessage: "foulsAllowedTechnical",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.fouls.allowed.technical",
              defaultMessage: "The maximum number of technical fouls allowed",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"foulsBeforeBonus"}
            label={formatMessage({
              id: "fouls.until.bonus",
              defaultMessage: "foulsBeforeBonus",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.fouls.until.bonus",
              defaultMessage: "The number of fouls before a bonus condition",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"foulsBeforeBonusOvertime"}
            label={formatMessage({
              id: "fouls.until.bonus.overtime",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.fouls.until.bonus.overtime",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"overtimeAllowed"}
            label={formatMessage({
              id: "overtime.allowed",
              defaultMessage: "overtimeAllowed",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.overtime.allowed",
              defaultMessage: "Is overtime allowed?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"overtimeLength"}
            label={formatMessage({
              id: "overtime.length",
              defaultMessage: "overtimeLength",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.duration.overtime",
              defaultMessage: "The length (in minutes) of an overtime period",
            })}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"simpleTargetScoreEndingAllowed"}
            label={formatMessage({
              id: "simple.target.score.ending.allowed",
              defaultMessage: "Enable Target Score Ending?",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.target.score.ending.allowed",
              defaultMessage: "Is the game allowed to end once the Target Score has been reached?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"midGameJumpBallAllowed"}
            label={formatMessage({
              id: "mid.game.jump.ball.allowed",
              defaultMessage: "Mid-game Jump Ball",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.mid.game.jump.ball.allowed",
              defaultMessage: "Are Jump balls allowed during the game to decide possession?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maximumPlayersOnCourt"}
            label={formatMessage({
              id: "max.players.on.court",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.max.players.on.court",
            })}
            rules={[
              {
                required: true,
                message: formatMessage(
                  {id: "form.help.required.field"},
                  {
                    field: formatMessage({
                      id: "max.players.on.court",
                    }),
                  },
                ),
              },
              {
                validator: (_, value) =>
                  value > 0
                    ? Promise.resolve()
                    : Promise.reject(
                      formatMessage({
                        id: "form.help.integer.greater.than.zero.field",
                      }, {
                        field: formatMessage({
                          id: "max.players.on.court",
                        }),
                      })
                    ),
              },
              ({getFieldValue}) =>
                createMaxPlayersValidator(getFieldValue, formatMessage, "form.matchProfile.error.maximumPlayersOnCourt"),
            ]}
          >
            <InputNumber style={{width: "100%"}}/>
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <EfficiencyCalculationSelect form={form}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"switchPlayingDirection"}
            label={formatMessage({
              id: "switch.play.direction",
              defaultMessage: "switchPlayingDirection",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.switch.play.direction",
              defaultMessage: "Switch direction of play after period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}></Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"resetFoulsAfterPeriods"}
            label={formatMessage({
              id: "reset.fouls.after.periods",
              defaultMessage: "resetFoulsAfterPeriods",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.reset.fouls.after.periods",
              defaultMessage: "Reset Team Fouls to 0 after period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"resetTimeoutsAfterPeriods"}
            label={formatMessage({
              id: "reset.timeouts.after.periods",
              defaultMessage: "resetTimeoutsAfterPeriods",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.reset.timeouts.after.periods",
              defaultMessage: "Reset Timeouts to 0 after period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}/>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"powerPlayAllowedPeriods"}
            label={formatMessage({
              id: "power.play.allowed.in.periods",
              defaultMessage: "Power Play allowed in period/s",
            })}
            tooltip={formatMessage({
              id: "form.help.match.profile.power.play.allowed.in.periods",
              defaultMessage: "Power Play allowed in period/s",
            })}
          >
            <Checkbox.Group options={checkboxOptions}/>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default BasketballForm;
